// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'contacts/SET_FILTER_OPTIONS' as const
export const SET_CONTACTS = 'contacts/SET_CONTACTS' as const
export const SET_ACTIVE_FILTERS = 'contacts/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'contacts/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'contacts/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'contacts/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_CONTACT_RECORD = 'contacts/UPDATE_CONTACT_RECORD' as const
export const ADD_CONTACT = 'contacts/ADD_CONTACT' as const
export const APPEND_CONTACTS = 'contacts/APPEND_CONTACTS' as const
export const REMOVE_CONTACT_FROM_LIST = 'contacts/REMOVE_CONTACT_FROM_LIST' as const
